module.exports = "## Crop freestyle or use an aspect ratio\r\n\r\nSometimes your photos need to be cropped to a certain aspect ratio to be able to properly displayed. Most social media sites such as Pinterest and Facebook or even smart TVs would stretch and distort your images if they are not properly cropped to fit the aspect ratio best practices set by those sources.\r\n\r\nOur image cropper has built-in aspect ratio button to help you easily apply an aspect ratio to your crop. You can also crop it freestyle if you choose to do so."


//////////////////
// WEBPACK FOOTER
// ./src/containers/Features/CropImages/crop-images-section-two.md
// module id = 1153
// module chunks = 0